module.exports = __webpack_public_path__ + "static/media/YM63_3.43ae4a01.jpg";